export const text = {
  themeName: "Racing Light",
};